module.exports = __webpack_public_path__ + "static/logo-35a8f5d7395a93e663394e6fc510fab2.png";